module.exports = __webpack_public_path__ + "static/media/palletTrader-ambassador-seal.5ce90b20.webp";